import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_URL from '../api';
import { useToast } from '../contexts/ToastContext';
import './Login.css';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const { success, error: toastError } = useToast();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const isFunPlatform = username.toLowerCase().includes('fun');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/auth/login`, { username, password });
      const { token, user } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      onLogin(token, user);
      success(`Ласкаво просимо, ${user.username}!`);
      navigate('/');
    } catch (err) {
      console.error('Login error details:', err.response?.data);
      const errorMsg = err.response?.data?.error || 'Помилка підключення до сервера';
      setError(errorMsg);
      toastError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          {isFunPlatform
            ? <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🎮 FunAdmin</div>
            : <img src="/km-logo.png" alt="Країна Мрій" className="login-logo-img" />
          }
          <p>Платформа навчання персоналу</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="login-error-box">{error}</div>}
          <div className="form-group">
            <label>Логін</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Введіть логін"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Введіть пароль"
              required
            />
          </div>
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Вхід...' : 'Увійти'}
          </button>
        </form>

      </div>
    </div>
  );
};

export default Login;
